import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

/**
 * 添加集中器
 * @param collection
 */
export function addCollection(collection) {
  return request({
    url: cmsServerContext + '/Collection/addCollection',
    method: 'post',
    data: collection
  })
}

/**
 * 查询集中器
 * @param myPage
 */
export function selectCollection(myPage) {
  return request({
    url: cmsServerContext + '/collection/selectCollection',
    method: 'post',
    data: myPage
  })
}

/**
 * 修改集中器
 * @param collection
 */
export function collectionModify(collection) {
  return request({
    url: cmsServerContext + '/collection/collectionModify',
    method: 'post',
    data: collection
  })
}

export function deleteByEntity(collection) {
  return request({
    url: cmsServerContext + '/collection/delete',
    method: 'post',
    data: collection
  })
}

